module.exports = __webpack_public_path__ + "static/media/imgGallery3.df2ab6da.jpg";